export default {
    title:
      "EBC Financial Group × ภาควิชาเศรษฐศาสตร์ มหาวิทยาลัย Oxford | EBC Financial Group",
    description:
      'EBC Financial Group  ร่วมกับมหาวิทยาลัย Oxford ได้เริ่มโครงการซีรีส์ "หน้าที่หลักของนักเศรษฐศาสตร์" (WERD) ซึ่งรวบรวมคณาจารย์ชั้นนำ เพื่อสำรวจประเด็นสำคัญด้านเศรษฐศาสตร์สภาพภูมิอากาศ เรียนรู้ว่าเราจะช่วยเสริมสร้างความรู้ด้านการเงินให้กับนักลงทุนได้อย่างไร เพื่อร่วมกันสร้างอนาคตทางเศรษฐกิจที่โปร่งใสและยั่งยืน',
    word1: "EBC Financial Group × ภาควิชาเศรษฐศาสตร์ มหาวิทยาลัย Oxford",
    word2: "เชื่อมโยงการวิจัยกับชีวิตจริง เพื่อสร้างวิธีนำทางเศรษฐกิจโลก",
    word3: "ไฮไลท์ของเรา",
    word4: "ร่วมมือกับเรา",
    word5: "ภาพรวม",
    word6: "ตอนที่ผ่านมาในซีรีส์ WERD",
    word7: "วิทยากรรับเชิญ",
    word8: "ข่าวประชาสัมพันธ์",
    word9: "เริ่มต้นจากความคิดง่ายๆ: การศึกษา คือ พลังแห่งกว่าเปลี่ยนแปลง",
    word10:
      "ที่ EBC Financial Group เราเชื่อว่าการเงินที่รับผิดชอบเริ่มต้นจากความรู้ที่ทุกคนเข้าถึงได้ เราจึงร่วมมือกับภาควิชาเศรษฐศาสตร์จากมหาวิทยาลัย Oxford เพื่อส่งมอบงานวิจัยเศรษฐกิจระดับโลกให้ทุกคนได้เรียนรู้",
    word11:
      'ผ่านซีรีส์ "หน้าที่หลักของนักเศรษฐศาสตร์" (WERD) เรามุ่งเน้นเสริมสร้างความรู้ทางการเงิน กระตุ้นการสนทนาที่สำคัญ และสนับสนุนการเติบโตของนักลงทุน ผู้นำ และนักคิดรุ่นใหม่',
    word12:
      "ความร่วมมือนี้สะท้อนถึงค่านิยมหลักของ EBC ได้แก่ ความยุติธรรม ความรับผิดชอบ และความซื่อสัตย์ แสดงถึงความมุ่งมั่นของเราในการสร้างอนาคตทางการเงินที่โปร่งใสและครอบคลุมมากขึ้น",
    word13: "สนทนาจริง สร้างผลลัพธ์ที่ชัดเจน",
    word14: "WERD ตอนที่ 1",
    word15: "นักเศรษฐศาสตร์มีบทบาทอะไรบ้าง?",
    word16: "รายละเอียด",
    word17:
      "เจาะลึกผลกระทบของพฤติกรรมการเลี่ยงภาษีต่อเศรษฐกิจโลกและระดับภูมิภาค พร้อมตอกย้ำบทบาทสำคัญของความรู้ทางการเงินในการรับมือกับปัญหาเศรษฐกิจที่ซับซ้อน",
    word18: "วิทยากร",
    word19: "Dr. Abi Adams ศาสตราจารย์ภาควิชาเศรษฐศาสตร์ ผู้ดำเนินรายการ",
    word20:
      "Dr. Sarah Clifford รองศาสตราจารย์ภาควิชาเศรษฐศาสตร์  มหาวิทยาลัย Oxford",
    word21:
      "David Barrett ประธานเจ้าหน้าที่บริหาร EBC Financial Group (UK) Ltd แขกรับเชิญพิเศษ",
    word22: "วันที่จัดกิจกรรม",
    word23: "1 มี.ค. 2024",
    word24: 'ซีรีส์ "หน้าที่หลักของนักเศรษฐศาสตร์" ประจำปี 2023-2024',
    word25: "รูปแบบบกิจกรรม",
    word26: "วิดิโอย้อนหลัง Zoom",
    word27: "WERD ตอนที่ 2",
    word28:
      "รักษาความยั่งยืน: สร้างสมดุลระหว่างการเติบโตทางเศรษฐกิจกับความยืดหยุ่นต่อสภาพภูมิอากาศ",
    word29:
      "สำรวจบทบาทของนโยบายเศรษฐกิจมหภาคในการสร้างสมดุลระหว่างเสถียรภาพทางเศรษฐกิจกับการรับมือความท้าทายด้านสิ่งแวดล้อมที่เร่งด่วนของโลก",
    word30:
      "Dr. Banu Demir Pakel ผู้ดำเนินรายการ รองผู้อำนวยการฝ่ายความร่วมมือระหว่างประเทศ และรองศาสตราจารย์ภาควิชาเศรษฐศาสตร์ มหาวิทยาลัย Oxford",
    word31: "Dr. Andrea Chiavari ผู้บรรยายหลักและผู้ร่วมอภิปราย",
    word32:
      "Dr. Nicola Ranger ผู้อำนวยการกลุ่มการเงินระดับโลกประจำศูนย์วิจัยการเปลี่ยนแปลงสิ่งแวดล้อม และนักวิจัยอาวุโส มหาวิทยาลัย Oxford",
    word33:
      "David Barrett ประธานเจ้าหน้าที่บริหาร EBC Financial Group (UK) Ltd ",
    word34:
      'พฤศจิกายน 2024 \n(ซีรีส์ "หน้าที่หลักของนักเศรษฐศาสตร์" ประจำปี 2024-2025)',
    word35:
      "กิจกรรม WERD ครั้งแรกที่มีการจัดเสวนาในรูปแบบ Hybrid ( Online และ Onsite)",
    word36: "วิทยากรรับเชิญ",
    word37: "Nicola Ranger",
    word38:
      "หัวหน้าฝ่ายความยืดหยุ่นด้านสิ่งแวดล้อมและโครงการ Martin Systems มหาวิทยาลัย Oxford",
    word39:
      "Nicola Ranger ผู้ดำรงตำแหน่งหัวหน้าโครงการ Martin Systems และความยืดหยุ่นด้านสิ่งแวดล้อม ภายใต้สถาบันวิจัยการเปลี่ยนแปลงสภาพภูมิอากาศแห่ง Oxford (ECI) ผู้ก่อตั้งกลุ่มวิจัยการเงินและเศรษฐกิจระดับโลก ร่วมมือกับ IMF ธนาคารโลก NGFS และเวทีความเสี่ยงด้านการเงินภูมิอากาศแห่งสหราชอาณาจักรในการพัฒนาเครื่องมือทดสอบแรงกดดันด้านการเงินภูมิอากาศ อีกทั้งยังเป็นที่ปรึกษาแก่สหภาพยุโรป กลุ่มผู้เชี่ยวชาญด้านการลงทุนอย่างยั่งยืนในตลาดเกิดใหม่ คณะที่ปรึกษาการจำแนกเทคโนโลยีสีเขียวของสหราชอาณาจักร กระทรวงการต่างประเทศและการพัฒนาแห่งสหราชอาณาจักร รวมถึง London School of Economics ",
    word40: "Andrea Chiavari",
    word41: "รองศาสตราจารย์ภาควิชาเศรษฐศาสตร์ มหาวิทยาลัย Oxford",
    word42:
      "Andrea Chiavari ผู้เชี่ยวชาญด้านเศรษฐศาสตร์มหภาค โดยมุ่งเน้นพลวัตขององค์กรและการเปลี่ยนแปลงทางเทคโนโลยี งานวิจัยของเขามุ่งเน้นการใช้แบบจำลองเศรษฐกิจเพื่อส่งเสริมการพัฒนาอย่างยั่งยืน วิเคราะห์ผลกระทบของการเปลี่ยนแปลงสภาพภูมิอากาศต่อประสิทธิภาพการผลิตขององค์กรและการจัดสรรทุน พร้อมเสริมความสามารถในการปรับตัวของเศรษฐกิจภายใต้ความไม่แน่นอน",
    word43: "Banu Demir Pakel",
    word44: "รองศาสตราจารย์ภาควิชาเศรษฐศาสตร์ มหาวิทยาลัย Oxford",
    word45:
      "Banu Demir Pakel ผู้เชี่ยวชาญด้านการค้าระหว่างประเทศและเศรษฐศาสตร์การพัฒนา งานวิจัยของเขามุ่งศึกษาว่าองค์กรต่าง ๆ รับมือกับแรงกระแทกทางการค้าอย่างไร และกลยุทธ์เหล่านี้ส่งผลต่อการเติบโตทางเศรษฐกิจมหภาคและการกระจายรายได้อย่างไร โดยเขาเป็นสมาชิกโครงการการค้าระหว่างประเทศและเศรษฐกิจภูมิภาคของศูนย์วิจัยนโยบายเศรษฐกิจแห่งยุโรป (CEPR) และเครือข่ายวิจัย CESifo แห่งเมืองมิวนิก",
    word46: "David Barrett",
    word47:
      "David Barrett ประธานเจ้าหน้าที่บริหาร EBC Financial Group (UK) Ltd ",
    word48:
      "David Barrett เป็น CEO ของ EBC Financial Group (UK) มีประสบการณ์กว่า 35 ปี เชี่ยวชาญด้านการกระจายการลงทุน และการป้องกันความเสี่ยงเชิงโครงสร้าง เขาได้เผชิญกับการเปลี่ยนแปลงในตลาดหลายครั้ง และเคยทำงานในตำแหน่งผู้นำของธนาคาร AIG ซึ่งเป็นกลุ่มการลงทุนที่ใหญ่ที่สุดในโลกของสหรัฐฯ ในช่วงเวลานั้น เขาได้ผลักดันการเปลี่ยนแปลงต่างๆ ที่เกี่ยวข้องกับโครงสร้างผลิตภัณฑ์ในวอลล์สตรีท และการควบคุมความเสี่ยงด้านการปฏิบัติตามกฎระเบียบ นอกจากนี้ เขายังได้สร้างกรอบแนวทางสำหรับการจัดการความเสี่ยงและสภาพคล่องในยุคหลังวิกฤตการเงิน",
    word49: "Sarah Clifford",
    word50: "รองศาสตราจารย์คณะเศรษฐศาสตร์ มหาวิทยาลัย Oxford",
    word51:
      "Dr.SARAH CLIFFORD เป็นผู้เชี่ยวชาญด้านเศรษฐศาสตร์สาธารณะ เชี่ยวชาญด้านพฤติกรรมทางเศรษฐกิจที่เกี่ยวข้องกับการเก็บภาษี โดยเฉพาะการบังคับใช้กฎหมาย งานวิจัยส่วนใหญ่เน้นไปที่ความครอบคลุมของการจัดเก็บภาษีนิติบุคคลระหว่างประเทศ การหลีกเลี่ยงภาษีข้ามชาติ และการหลีกเลี่ยงภาษีเงินได้บุคคลธรรมดาในครัวเรือนและยังเชี่ยวชาญในด้านเศรษฐศาสตร์สาธารณะและเศรษฐศาสตร์จุลภาคประยุกต์ เป็นต้น",
    word52: "Abi Adams-Prassl",
    word53:
      "ศาสตราจารย์คณะเศรษฐศาสตร์，วิทยาลัย Nuffield ，รองหัวหน้าโครงการพันธกิจสัมพันธ์กับหน่วยงานภายนอก",
    word54:
      "งานวิจัยของ Abi Adams-Prassl เกี่ยวกับเศรษฐศาสตร์ประยุกต์ เขามักจะมุ่งเน้นไปที่เศรษฐมิติของตัวเลือกของผู้บริโภคและครอบครัว หัวข้อหลักในการวิจัยคือ การพัฒนาวิธีการเชิงประจักษ์เพื่อนำรูปแบบใหม่ๆ มาสู่การตัดสินใจด้านข้อมูล เปิดเผยชุดข้อมูลขนาดใหญ่เพื่อทำความเข้าใจตลาดแรงงานได้ดีขึ้น และการพัฒนากรอบการทำงานสำหรับการวัดปริมาณการเข้าถึงความยุติธรรมในระบบกฎหมายของสหราชอาณาจักร",
    word55: "เรียนรู้เพิ่มเติม",
    word56: "ข่าวประชาสัมพันธ์",
    word57: "ร่วมกันเปิดบทใหม่แห่งความร่วมมือระดับโลก",
    word58:
      "EBC มุ่งสร้างความร่วมมือกับสถาบันและผู้นำการเปลี่ยนแปลงทั่วโลกที่มีวิสัยทัศน์เดียวกัน เพื่อร่วมกันขับเคลื่อนอนาคตทางเศรษฐกิจที่ยั่งยืน",
    word59: "ติดต่อเรา",
    placeholder1: "ชื่อ-นามสกุล",
    placeholder2: "อีเมล",
    placeholder3: "เบอร์โทรศัพท์",
    placeholder4: "รหัสยืนยัน",
}
